import { Counter } from "features/analytics/Components/Counter";
import Section from "features/analytics/Components/Section";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

function Counters() {
	const { t } = useTranslation();
	const { touchpoints, opportunities, solutions, actions } = useSelector((state) => state.analytics?.journeyTrend?.currentData);

	return (
		<Section height="132">
			<Counter
				title={t("TOUCHPOINTS")}
				value={touchpoints?.length}
				background="linear-gradient(178deg, #EFF6FF 1.53%, #FFF 104.23%);"
				border="#DBEAFE"
				icon="BULLSEYES-POINTER"
				iconColor="#3B82F6"
			/>
			<Counter title={t("OPPORTUNITIES")} value={opportunities?.length} icon="OPPORTUNITY" iconColor="#14B8A6" />
			<Counter title={t("SOLUTIONS")} value={solutions?.length} icon="SOLUTION" iconColor="#A855F7" />
			<Counter title={t("JS_80")} value={actions?.length} icon="MENU-ACTION" iconColor="#3B82F6" />
		</Section>
	);
}

Counters.displayName = "Counters";
export default Counters;
